"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = Popover;
exports.PopoverAnchor = PopoverAnchor;
exports.PopoverContent = PopoverContent;
exports.PopoverDescription = PopoverDescription;
exports.PopoverHeader = PopoverHeader;
exports.PopoverTitle = PopoverTitle;
exports.PopoverTrigger = PopoverTrigger;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _radixUi = require("radix-ui");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "align", "sideOffset", "container"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Popover(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Popover.Root, _objectSpread(_objectSpread({
    "data-slot": "popover"
  }, props), {}, {
    "data-sentry-element": "PopoverPrimitive.Root",
    "data-sentry-component": "Popover",
    "data-sentry-source-file": "popover.tsx"
  }));
}
function PopoverTrigger(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Popover.Trigger, _objectSpread(_objectSpread({
    "data-slot": "popover-trigger"
  }, props), {}, {
    "data-sentry-element": "PopoverPrimitive.Trigger",
    "data-sentry-component": "PopoverTrigger",
    "data-sentry-source-file": "popover.tsx"
  }));
}
function PopoverContent(_ref3) {
  var className = _ref3.className,
    _ref3$align = _ref3.align,
    align = _ref3$align === void 0 ? "center" : _ref3$align,
    _ref3$sideOffset = _ref3.sideOffset,
    sideOffset = _ref3$sideOffset === void 0 ? 4 : _ref3$sideOffset,
    container = _ref3.container,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Popover.Portal, {
    container: container,
    "data-sentry-element": "PopoverPrimitive.Portal",
    "data-sentry-component": "PopoverContent",
    "data-sentry-source-file": "popover.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Popover.Content, _objectSpread(_objectSpread({
      "data-slot": "popover-content",
      align: align,
      sideOffset: sideOffset,
      className: (0, _utils.cn)("z-floating flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-4 rounded-lg bg-popover p-4 has-data-[slot=command]:gap-0 has-data-[slot=command]:p-0 has-[>[data-slot=card]]:block has-[>[data-slot=card]]:bg-transparent has-[>[data-slot=card]]:p-0 has-[>[data-slot=card]]:shadow-none has-[>[data-slot=card]]:ring-0 text-sm text-popover-foreground shadow-md ring-1 ring-black/5 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className)
    }, props), {}, {
      "data-sentry-element": "PopoverPrimitive.Content",
      "data-sentry-source-file": "popover.tsx"
    }))
  });
}
function PopoverAnchor(_ref4) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_radixUi.Popover.Anchor, _objectSpread(_objectSpread({
    "data-slot": "popover-anchor"
  }, props), {}, {
    "data-sentry-element": "PopoverPrimitive.Anchor",
    "data-sentry-component": "PopoverAnchor",
    "data-sentry-source-file": "popover.tsx"
  }));
}
function PopoverHeader(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "popover-header",
    className: (0, _utils.cn)("flex flex-col gap-1 text-sm", className)
  }, props), {}, {
    "data-sentry-component": "PopoverHeader",
    "data-sentry-source-file": "popover.tsx"
  }));
}
function PopoverTitle(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "popover-title",
    className: (0, _utils.cn)("font-medium", className)
  }, props), {}, {
    "data-sentry-component": "PopoverTitle",
    "data-sentry-source-file": "popover.tsx"
  }));
}
function PopoverDescription(_ref7) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({
    "data-slot": "popover-description",
    className: (0, _utils.cn)("text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-component": "PopoverDescription",
    "data-sentry-source-file": "popover.tsx"
  }));
}